import type { GetAnswersChatSession } from "../components/doubts-dashboard/GetAnswersChat/types";

const AINA_CHAT_BOOTSTRAP_KEY = "doubts_aina_chat_bootstrap_v1";

export function saveAinaChatBootstrap(session: GetAnswersChatSession): void {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.setItem(
      AINA_CHAT_BOOTSTRAP_KEY,
      JSON.stringify(session),
    );
  } catch {
    // Route state remains the primary handoff; storage is only a best-effort fallback.
  }
}

export function consumeAinaChatBootstrap(): GetAnswersChatSession | null {
  if (typeof window === "undefined") return null;

  try {
    const raw = window.sessionStorage.getItem(AINA_CHAT_BOOTSTRAP_KEY);
    window.sessionStorage.removeItem(AINA_CHAT_BOOTSTRAP_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as GetAnswersChatSession;
  } catch {
    window.sessionStorage.removeItem(AINA_CHAT_BOOTSTRAP_KEY);
    return null;
  }
}
